<!-- ALERT -->
<div class="Alert Alert--blue" *ngIf="partialAuth" >
    <h3 *ngIf="hasFullAccess()" data-cy="subscription-login">You must be <b>logged in</b> to read this report in full.</h3>
    <h3 *ngIf="!hasFullAccess()" data-cy="subscription-login-upgrade">You must be <b>logged in</b> and you need to <b>upgrade your subscription</b> to read this report in full.</h3>
</div>
<div class="Alert Alert--blue" *ngIf="!partialAuth">
    <h3 data-cy="subscription-upgrade">You need to <b>upgrade your subscription</b> to read this report in full.</h3>
</div>
